module.exports = __webpack_public_path__ + "img/house.ff510677.svg";